import { useState } from 'react';
import { getUrl } from 'aws-amplify/storage';
import BP from '../images/biglogo.png'; 
import { EnvelopeIcon } from '@heroicons/react/24/outline';

function TextBannerWithDownload() {
  const [files, setFiles] = useState([
    { name: 'EW_Referral Form.docx', path: 'public/Referral Form Enhanced Wellbeing.docx' }
  ]);

  const handleFileDownload = async (filePath, fileName) => {
    try {
      const getUrlResult = await getUrl({ path: filePath });
      if (getUrlResult.url) {
        const response = await fetch(getUrlResult.url);
        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      } else {
        throw new Error('Failed to generate a signed URL');
      }
    } catch (error) {
      console.error('Error downloading file:', error);
      alert('Download failed');
    }
  };

  return (
    <div className="px-6 py-12 sm:py-16 lg:px-8 bg-gradient-to-b from-custom-4 to-custom-6 shadow-xl">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-5xl mx-auto items-center">
        <div className="lg:col-span-2 text-center">
          <div className="mt-6 text-lg leading-8 text-gray-900 text-left">
          If you are interested in exploring our services further, we invite you to download our form available here. Please fill out the forms at your convenience. This will allow us to better understand your needs and provide NDIS supports.
          </div>
          <div className="mt-8">
            <div className="space-y-4">
              {files.map(file => (
                <div key={file.name} className="flex justify-between items-center p-4 border border-gray-300 rounded-lg shadow-sm bg-white">
                  <span className="text-gray-700">{file.name}</span>
                  <button
                    onClick={() => handleFileDownload(file.path, file.name)}
                    className="text-blue-500 hover:text-blue-700"
                  >
                    Download
                  </button>
                </div>
              ))}
            </div>
            <div className="mt-6 text-lg leading-8 text-gray-900 text-left">
              Please send the form to:
            </div>
            <br />
            <div className="flex gap-x-4">
                <dt className="flex-none">
                  <span className="sr-only">Email</span>
                  <EnvelopeIcon className="h-7 w-6 text-gray-400" aria-hidden="true" />
                </dt>
                <dd>
                  <a className="text-xl hover:text-blue-500" href="mailto:info@enhancedwellbeing.com.au">
                    info@enhancedwellbeing.com.au
                  </a>
                </dd>
              </div>
          </div>
        </div>
        <div className="flex justify-center lg:justify-end lg:col-span-1">
          <img
            src={BP}
            alt="Banner Image"
            className="mt-4 w-48 lg:w-80 h-auto object-cover" 
          />
        </div>
      </div>
    </div>
  );
}

export default TextBannerWithDownload;


